import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {catchError} from 'rxjs/operators';
import {ErrorStreamService} from '../shared-components/error-modal/error-stream.service';
import {throwError} from 'rxjs';

@Injectable()
export class HttpInterceptorService implements HttpInterceptor {

  constructor(public errorStreamService: ErrorStreamService) {

  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(catchError((error: HttpErrorResponse) => this.handleError(error)));
  }

  handleError(error: HttpErrorResponse): Observable<never> {
    let errorMessage = '';
    try {
      if(error.error.Description) errorMessage = `${error.error.Description}`;
      else errorMessage = `${error.status} ${error.statusText}`;
    } catch (e) {
      errorMessage = `${error.status} ${error.statusText}`;
    }
    this.errorStreamService.catchStream$.next(errorMessage)
    return throwError(() => errorMessage);
  }

}
